import {
  listTrainingModules,
  getTrainingModule,
} from '@metaonia/api-client';
import { useQuery } from '@tanstack/react-query';

import type {
  ListTrainingModules200,
  GetTrainingModule200,
} from '@metaonia/api-client';

export function useTrainingModules() {
  return useQuery({
    queryKey: ['training-modules'],
    queryFn: async () => {
      const response = await listTrainingModules();
      return (response as ListTrainingModules200).data;
    },
    staleTime: 24 * 60 * 60 * 1000,
  });
}

export function useTrainingModule(moduleId: string) {
  return useQuery({
    queryKey: ['training-modules', moduleId],
    queryFn: async () => {
      const response = await getTrainingModule(moduleId);
      return (response as GetTrainingModule200).data;
    },
    staleTime: 24 * 60 * 60 * 1000,
    enabled: !!moduleId,
  });
}

// Re-export types from generated client for consumers
export type { ListTrainingModules200, GetTrainingModule200, TrainingModuleSummary } from '@metaonia/api-client';
